export const recentSearchesKey = 'recentSearches';

export const searchTermQueryKey = 'q';
